module.exports = __webpack_public_path__ + "static/media/DeLijn.5d010f56.svg";